import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";
import { allKontakDaruratKey } from "./useFetchKontakDarurat";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";

export async function removeKontakDarurat(ID: number) {
    const res = await ApiClient.delete(
        `/RemoveEmergencyContact/${ID}`
    );
    return res.data;
}

export const useRemoveKontakDarurat = mutationWrapper(removeKontakDarurat, {
    onSuccess: () => {
        getQueryClient().invalidateQueries(allKontakDaruratKey);
        getQueryClient().invalidateQueries(checkProfileKey)
    },
});
